const routes = [
  // Sessão de Veículos
  {
    path: '/frotas/veiculo',
    name: 'vehicles',
    component: () => import('@/views/sistema/frotas/veiculo/Veiculo.vue'),
    meta: { breadcrumb: [{ title: 'Frotas' }, { title: 'Veículos' }] },
  },
  {
    path: '/frotas/veiculo/novo',
    name: 'vehiclesNew',
    component: () => import('@/views/sistema/frotas/veiculo/VeiculoNew.vue'),
    meta: { breadcrumb: [{ title: 'Frotas' }, { title: 'Veículos' }, { title: 'Novo' }] },
  },
  {
    path: '/frotas/veiculo/:id/editar',
    name: 'vehiclesUpdate',
    component: () => import('@/views/sistema/frotas/veiculo/VeiculoNew.vue'),
    meta: { breadcrumb: [{ title: 'Frotas' }, { title: 'Veículos' }, { title: 'Editar' }] },
  },
  // Sessão de Checklist
  {
    path: '/frotas/checklist',
    name: 'checklist',
    component: () => import('@/views/sistema/frotas/checklist/Checklist.vue'),
    meta: { breadcrumb: [{ title: 'Frotas' }, { title: 'Checklist' }] },
  },
  {
    path: '/frotas/checklist/novo',
    name: 'checklistNew',
    component: () => import('@/views/sistema/frotas/checklist/ChecklistNew.vue'),
    meta: { breadcrumb: [{ title: 'Frotas' }, { title: 'Checklist' }, { title: 'Nova Checklist' }] },
  },
  {
    path: '/frotas/checklist/:id/editar',
    name: 'checklistUpdate',
    component: () => import('@/views/sistema/frotas/checklist/ChecklistNew.vue'),
    meta: { breadcrumb: [{ title: 'Frotas' }, { title: 'Checklist' }, { title: 'Editar Checklist' }] },
  },
  {
    path: '/frotas/veiculo/:idVehicle/checklist',
    name: 'vehiclesChecklist',
    component: () => import('@/views/sistema/frotas/checklist/Checklist.vue'),
    meta: {
      breadcrumb: [{ title: 'Frotas' }, { title: 'Veículos' }, { title: 'Checklist' }],
    },
  },
  {
    path: '/frotas/veiculo/:idVehicle/checklist/novo',
    name: 'vehiclesChecklistNew',
    component: () => import('@/views/sistema/frotas/checklist/ChecklistNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Frotas' }, { title: 'Veículos' }, { title: 'Checklist' }, { title: 'Editar' }],
    },
  },
  // Sessão de Manutenção - [OK]
  {
    path: '/frotas/manutencao',
    name: 'maintenance',
    component: () => import('@/views/sistema/frotas/manutencao/Manutencao.vue'),
    meta: { breadcrumb: [{ title: 'Frotas' }, { title: 'Manutenções' }] },
  },
  {
    path: '/frotas/manutencao/novo',
    name: 'maintenanceNew',
    component: () => import('@/views/sistema/frotas/manutencao/ManutencaoNew.vue'),
    meta: { breadcrumb: [{ title: 'Frotas' }, { title: 'Manutenções' }, { title: 'Nova Manutenção' }] },
  },
  {
    path: '/frotas/manutencao/:id/editar',
    name: 'maintenanceUpdate',
    component: () => import('@/views/sistema/frotas/manutencao/ManutencaoNew.vue'),
    meta: { breadcrumb: [{ title: 'Frotas' }, { title: 'Manutenções' }, { title: 'Editar Manutenção' }] },
  },
  {
    path: '/frotas/veiculo/:idVehicle/manutencao',
    name: 'vehiclesMaintenance',
    component: () => import('@/views/sistema/frotas/manutencao/Manutencao.vue'),
    meta: {
      breadcrumb: [{ title: 'Frotas' }, { title: 'Veículos' }, { title: 'Manutenção' }],
    },
  },
  {
    path: '/frotas/veiculo/:idVehicle/manutencao/novo',
    name: 'vehiclesMaintenanceNew',
    component: () => import('@/views/sistema/frotas/manutencao/ManutencaoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Frotas' }, { title: 'Veículos' }, { title: 'Manutenção' }, { title: 'Novo' }],
    },
  },
  // Sessão de Encargos
  {
    path: '/frotas/encargo',
    name: 'charge',
    component: () => import('@/views/sistema/frotas/encargo/Encargo.vue'),
    meta: {
      breadcrumb: [{ title: 'Frotas' }, { title: 'Encargo' }],
    },
  },
  {
    path: '/frotas/encargo/novo',
    name: 'chargeNew',
    component: () => import('@/views/sistema/frotas/encargo/EncargoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Frotas' }, { title: 'Encargo' }, { title: 'Novo' }],
    },
  },
  {
    path: '/frotas/:id/encargo/editar',
    name: 'chargeUpdate',
    component: () => import('@/views/sistema/frotas/encargo/EncargoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Frotas' }, { title: 'Encargo' }, { title: 'Editar' }],
    },
  },
  {
    path: '/frotas/veiculo/:idVehicle/encargo',
    name: 'vehiclesCharge',
    component: () => import('@/views/sistema/frotas/encargo/Encargo.vue'),
    meta: { breadcrumb: [{ title: 'Frotas' }, { title: 'Veículos' }, { title: 'Encargo' }] },
  },
  {
    path: '/frotas/veiculo/:idVehicle/encargo/novo',
    name: 'vehiclesChargeNew',
    component: () => import('@/views/sistema/frotas/encargo/EncargoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Frotas' }, { title: 'Veículos' }, { title: 'Encargo' }, { title: 'Novo' }],
    },
  },
  // Sessão de Combustível - [OK]
  {
    path: '/frotas/combustivel',
    name: 'fuel',
    component: () => import('@/views/sistema/frotas/combustivel/Combustivel.vue'),
    meta: {
      breadcrumb: [{ title: 'Frotas' }, { title: 'Combustível' }],
    },
  },
  {
    path: '/frotas/combustivel/novo',
    name: 'fuelNew',
    component: () => import('@/views/sistema/frotas/combustivel/CombustivelNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Frotas' }, { title: 'Combustível' }, { title: 'Novo' }],
    },
  },
  {
    path: '/frotas/combustivel/:id/editar',
    name: 'fuelUpdate',
    component: () => import('@/views/sistema/frotas/combustivel/CombustivelNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Frotas' }, { title: 'Combustível' }, { title: 'Editar' }],
    },
  },
  {
    path: '/frotas/veiculo/:idVehicle/combustivel',
    name: 'vehiclesFuel',
    component: () => import('@/views/sistema/frotas/combustivel/Combustivel.vue'),
    meta: {
      breadcrumb: [{ title: 'Frotas' }, { title: 'Veículos' }, { title: 'Combustível' }],
    },
  },
  {
    path: '/frotas/veiculo/:idVehicle/combustivel/novo',
    name: 'vehiclesFuelNew',
    component: () => import('@/views/sistema/frotas/combustivel/CombustivelNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Frotas' }, { title: 'Veículos' }, { title: 'Combustível' }, { title: 'Editar' }],
    },
  },
  // Sessão de Movimentação
  {
    path: '/frotas/veiculo/:idVehicle/movimentacao',
    name: 'vehiclesBaseContractLog',
    component: () => import('@/views/sistema/frotas/veiculo/movimentacao/Movimentacao.vue'),
    meta: {
      breadcrumb: [{ title: 'Frotas' }, { title: 'Veículos' }, { title: 'Movimentação' }],
    },
  },
  {
    path: '/frotas/veiculo/:idVehicle/movimentacao/novo',
    name: 'vehiclesBaseContractLogNew',
    component: () => import('@/views/sistema/frotas/veiculo/movimentacao/MovimentacaoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Frotas' }, { title: 'Veículos' }, { title: 'Movimentação' }, { title: 'Novo' }],
    },
  },
  {
    path: '/frotas/veiculo/:idVehicle/movimentacao/:id/editar',
    name: 'vehiclesBaseContractLogUpdate',
    component: () => import('@/views/sistema/frotas/veiculo/movimentacao/MovimentacaoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Frotas' }, { title: 'Veículos' }, { title: 'Movimentação' }, { title: 'Editar' }],
    },
  },
]

export default routes
